var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsDialogCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.415,
    y: 0.665,
    width: 25.921,
    height: 25.921,
    rx: 12.96,
    fill: "#3C3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.865 10.136l-6.978 6.978M10.887 10.136l6.978 6.978",
    stroke: "#fff",
    strokeWidth: 1.745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.415,
    y: 0.665,
    width: 25.921,
    height: 25.921,
    rx: 12.96,
    stroke: "#fff",
    strokeWidth: 1.329
  })));
}
export default __webpack_public_path__ + "static/media/rewardsDialogCross.94b7d7dc.svg";
export { SvgRewardsDialogCross as ReactComponent };